import { render } from "./ProjectPageHeader.vue?vue&type=template&id=789d13b8"
import script from "./ProjectPageHeader.vue?vue&type=script&lang=js"
export * from "./ProjectPageHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Website/Website/front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__